import { getService } from '@Client/runner.hooks/useService';
import React, { useState, useEffect } from 'react';
import { DisplayStatus } from '@Shared.Angular/@types/core/contracts/constants/displayStatus';
import { ThemeSchemaStatus } from '@Shared.Angular/@types/core/contracts/constants/themeSchemaStatus';
import { WorkflowAccessLevel } from '@Shared.Angular/@types/core/contracts/constants/workflowAccessLevel';

interface StatusBadgeProps {
  status: DisplayStatus | ThemeSchemaStatus | WorkflowAccessLevel;
}

export const StatusBadge = ({ status: initialStatus }: StatusBadgeProps) => {
  const APP_CONFIG = getService('APP_CONFIG');
  const [status, setStatus] = useState(initialStatus);

  useEffect(() => {
    if (
      initialStatus === DisplayStatus.Public &&
      !APP_CONFIG.enablePublicProcessMaps
    ) {
      setStatus(DisplayStatus.Published);
    } else {
      setStatus(initialStatus);
    }
  }, [initialStatus]);

  const getStatusDisplay = () => {
    switch (status) {
      case DisplayStatus.Draft:
        return 'val-badge--draft';
      case DisplayStatus.Published:
      case DisplayStatus.Internal:
        return 'val-badge--published';
      case DisplayStatus.Public:
        return 'val-badge--published-public';
      case DisplayStatus.PublicSSO:
      case WorkflowAccessLevel.PublicForm:
      case DisplayStatus.AwaitingPublishApproval:
        return 'val-badge--published-sso';
      default:
        return '';
    }
  };

  return (
    <div className="flex">
      <span className={`val-badge ${getStatusDisplay()}`} title={status}>
        {status}
      </span>
    </div>
  );
};
